export default __webpack_public_path__ + "static/media/logo.67547f92.png";